import React from "react";
import styles from './index.module.css';
import { BookIcon, ChessEngine, ExploreBG, ExploreIcon, ExploreImg, Move, MoveReview } from "../../assets";

const FeatureCards = () => {

    return (
        <main className={styles["main"]}>

  <ul>
    <li>
      <article>
        <img src={ChessEngine} width={64} height={64} />

        <h3>Analyze</h3>
        <p>
          Enjoy a rich selection of chess engines and achieve top speeds with dedicated hardware at the best prices.
        </p>
      </article>
    </li>
    <li>
      <article className="flex items-center justify-center">
      <ExploreImg />

        <h3>Explore</h3>
        <p>
          Our game database has more than 5.4 Million master games as well a millions of chess positions already analyzed at amazing depths.
        </p>
      </article>
    </li>
    <li>
      <article>
       <BookIcon />
       <h3>Learn</h3>
        <p>
          A unique way to write detailed variations for the best chess learning experience ! Save your variations for later review and start building your very own book.
        </p>
      </article>
    </li>
    <li>
      <article>
        <MoveReview />

        <h3>Review</h3>
        <p>
          Get immediate feedback for every move to get an idea of how good or bad it was. Follow know book moves and even annotate the moves yourself.
        </p>
      </article>
    </li>
  </ul>
</main>
    )
}

export default FeatureCards;